import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-367e84ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal rounded",
  id: "myModalCompany",
  "data-target": ".bd-example-modal-lg"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  class: "modal-header p-4",
  style: {"gap":"1rem","display":"flex"}
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div style=\"background-color:aliceblue;width:2rem;height:2rem;border-radius:8px;display:flex;align-items:center;justify-content:center;\" data-v-367e84ec><svg width=\"70\" height=\"70\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-367e84ec><rect width=\"40\" height=\"40\" rx=\"10\" fill=\"#F9F9F9\" data-v-367e84ec></rect><g clip-path=\"url(#clip0_279_226)\" data-v-367e84ec><path opacity=\"0.3\" d=\"M20.0001 25H13.2605V18.75H11.014V28.75C11.014 29.4414 11.516 30 12.1373 30H21.1233C21.7446 30 22.2466 29.4414 22.2466 28.75V18.75H20.0001V25ZM31.0431 15.5547L28.0489 10.5547C27.8383 10.207 27.4873 10 27.1117 10H12.8884C12.5129 10 12.1618 10.207 11.9547 10.5547L8.96055 15.5547C8.4621 16.3867 8.99565 17.5 9.89426 17.5H30.1094C31.0045 17.5 31.538 16.3867 31.0431 15.5547ZM26.7396 29.375C26.7396 29.7188 26.9923 30 27.3012 30H28.4245C28.7334 30 28.9861 29.7188 28.9861 29.375V18.75H26.7396V29.375Z\" fill=\"#203972\" data-v-367e84ec></path><path d=\"M31.043 15.5547L28.0488 10.5547C27.8382 10.207 27.4872 10 27.1116 10H12.8883C12.5127 10 12.1617 10.207 11.9546 10.5547L8.96043 15.5547C8.46198 16.3867 8.99553 17.5 9.89414 17.5H30.1093C31.0044 17.5 31.5379 16.3867 31.043 15.5547Z\" fill=\"#203972\" data-v-367e84ec></path></g><defs data-v-367e84ec><clipPath id=\"clip0_279_226\" data-v-367e84ec><rect width=\"22.4652\" height=\"25\" fill=\"white\" transform=\"translate(8.7674 7.5)\" data-v-367e84ec></rect></clipPath></defs></svg></div><h5 class=\"modal-title\" style=\"font-size:1rem;text-align:left;width:100%;\" data-v-367e84ec>Vincular Companhias a Loja</h5>", 2)
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1.8rem","font-weight":"600","margin-bottom":"1rem","color":"var(--cor_texto_2)"} }, "x", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "modal-body d-flex flex-column",
  style: {"background-color":"#D9D9D9","gap":"1rem","padding":"1rem","border-radius":"0rem  0rem 0.475rem 0.475rem"}
}
const _hoisted_10 = {
  class: "col-md-12",
  style: {"border-radius":"8px","background-color":"#ffffff","display":"flex","padding":"1rem","gap":"1rem"}
}
const _hoisted_11 = {
  class: "col-md-6 d-flex flex-column justify-content-start align-items-start",
  style: {"border-right":"1px solid #D9D9D9"}
}
const _hoisted_12 = { style: {"font-size":"1.2rem","font-weight":"500","margin-bottom":"0"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"1rem","font-weight":"400","margin-bottom":"0","opacity":"0.8"} }, "Loja", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"80%","width":"1px"} }, null, -1))
const _hoisted_15 = {
  class: "col-md-6 d-flex align-items-center justify-content-start",
  style: {"gap":"1rem"}
}
const _hoisted_16 = { style: {"font-size":"1.5rem","margin-bottom":"0","font-weight":"600"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"font-size":"1rem","margin-bottom":"0","font-weight":"500"} }, "Companhias vinculados", -1))
const _hoisted_18 = {
  class: "col-md-12 p-0 h-100 flex-column",
  style: {"border-radius":"8px","background-color":"#ffffff","display":"flex","padding":"1rem"}
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-12 d-flex justify-content-between align-items-center",
  style: {"padding":"1rem","border-bottom":"1px solid #D9D9D9"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Companhias vinculados"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "Ações")
], -1))
const _hoisted_20 = {
  key: 0,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Esta loja não possui vinculo")
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "d-flex justify-content-center col-md-12 d-flex align-items-center",
  style: {"padding":"1rem"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
], -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { style: {"min-height":"4rem"} }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trash-alt",
  "aria-hidden": "true",
  style: {"font-size":"1.1rem","margin":"0","padding":"0"}
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  class: "btn btn-sm background_btn_1_opct",
  type: "button",
  disabled: ""
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1))
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 1,
  class: "btn btn-sm background_btn_1",
  type: "button",
  disabled: "",
  style: {"height":"3rem","width":"12rem","font-size":"1rem","color":"#ffffff"}
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              type: "button",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetSelectValues && _ctx.resetSelectValues(...args))),
              ref: "refModalDel",
              style: {"background-color":"transparent","border":"none"}
            }, _hoisted_8, 512)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.relationData?.fantasy_name), 1),
                _hoisted_13
              ]),
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.lenghtRealation), 1),
                _hoisted_17
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              (_ctx.relationDataInfo.length === 0 && _ctx.isLoading === false? true: false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
                : _createCommentVNode("", true),
              (!_ctx.isLoading)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.relationDataInfo, (user) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      (_openBlock(), _createElementBlock("div", {
                        key: user?.id,
                        class: "col-md-12 d-flex justify-content-between align-items-center",
                        style: {"padding":"1rem"}
                      }, [
                        _createElementVNode("span", null, _toDisplayString(user?.fantasy_name), 1),
                        (!_ctx.isLoadingButton)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm background_btn_1_opct",
                              onClick: ($event: any) => (_ctx.deletRelation(user?.id))
                            }, _hoisted_29, 8, _hoisted_27))
                          : _createCommentVNode("", true),
                        (_ctx.isLoadingButton)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_30, _hoisted_32))
                          : _createCommentVNode("", true)
                      ]))
                    ]))
                  }), 256))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("form", {
              class: "modal-footer d-flex flex-row justify-content-between rounded",
              style: {"padding":"1rem","background-color":"#ffffff"},
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmitFunction && _ctx.onSubmitFunction(...args)), ["prevent"]))
            }, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.value1,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.value1) = $event)),
                filterable: "",
                multiple: "",
                placeholder: "Selecione novas companhias",
                tyle: "width: 240px",
                class: "col-md-9",
                "no-data-text": "Sem dados para serem adicionados"
              }, {
                default: _withCtx(() => [
                  (_ctx.isLoadSelect)
                    ? (_openBlock(), _createBlock(_component_el_option, { key: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "submit",
                    class: "btn btn-sm background_btn_1",
                    disabled: _ctx.value1.length === 0? true : false,
                    style: {"height":"3rem","width":"12rem","font-size":"1rem","color":"#ffffff"}
                  }, "Adicionar", 8, _hoisted_34))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("button", _hoisted_35, [
                    _hoisted_36,
                    _createTextVNode(" Loading... ")
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}